import type { DeleteRedirectionAction } from '..';
import { REDIRECTION_DELETE } from '../actionTypes';

const deleteRedirection = (id: string | number): DeleteRedirectionAction => ({
	type: REDIRECTION_DELETE,
	payload: id,
});

export default deleteRedirection;
